/**
 * Växlar mellan decimalpunkt och decimalkomma. toComma är riktningen mot det som visas för användaren,
 * toComma: false riktningen mot det backend vill ha.
 *
 * Värden som inte går att konvertera lämnas orörda: tal utan decimaldel returneras som tal, så att ett fälts
 * värde inte byter typ i onödan, och allt som varken är sträng eller tal blir null.
 */
export const replaceSeparator = ({ value, toComma = true }: { value?: string | number; toComma?: boolean }) => {
    if (typeof value === "number") {
        const text = String(value);

        return toComma && text.includes(".") ? text.replace(".", ",") : value;
    }

    if (typeof value !== "string") {
        return null;
    }

    return toComma ? value.replace(".", ",") : value.replace(",", ".");
};
